module.exports = __webpack_public_path__ + "static/media/NI.810795b5.svg";